import React, { useEffect, useState } from 'react';

const TileBoard = ({ image, gridSize, onWin }) => {
  const [tiles, setTiles] = useState([]);
  const [selectedTile, setSelectedTile] = useState(null);

  useEffect(() => {
    const tileArray = [];
    for (let row = 0; row < gridSize; row++) {
      for (let col = 0; col < gridSize; col++) {
        tileArray.push({
          id: row * gridSize + col,
          row,
          col,
          correctIndex: row * gridSize + col,
        });
      }
    }
    const shuffled = [...tileArray].sort(() => Math.random() - 0.5);
    setTiles(shuffled);
  }, [gridSize]);

  const handleTileClick = (index) => {
    if (selectedTile === null) {
      setSelectedTile(index);
    } else {
      const newTiles = [...tiles];
      [newTiles[selectedTile], newTiles[index]] = [newTiles[index], newTiles[selectedTile]];
      setTiles(newTiles);
      setSelectedTile(null);

      const isSolved = newTiles.every((tile, idx) => tile.correctIndex === idx);
      if (isSolved) {
        onWin();
      }
    }
  };

  const getBackgroundPosition = (row, col) => {
    return `${(col / (gridSize - 1)) * 100}% ${(row / (gridSize - 1)) * 100}%`;
  };

  return (
    <div
      className="relative"
      style={{
        width: '90vmin',
        height: '90vmin',
        display: 'grid',
        gridTemplateColumns: `repeat(${gridSize}, 1fr)`,
        gridTemplateRows: `repeat(${gridSize}, 1fr)`,
        border: '4px solid #FF54D7',
        gap: '0px',
      }}
    >
      {tiles.map((tile, index) => (
        <div
          key={index}
          className={`w-full h-full cursor-pointer transition-transform duration-150 ${selectedTile === index ? 'ring-4 ring-pink-500 scale-105' : 'hover:scale-105'}`}
          onClick={() => handleTileClick(index)}
          style={{
            backgroundImage: `url(${image})`,
            backgroundSize: `${gridSize * 100}% ${gridSize * 100}%`,
            backgroundPosition: getBackgroundPosition(tile.row, tile.col),
            backgroundRepeat: 'no-repeat',
          }}
        />
      ))}
    </div>
  );
};

export default TileBoard;
